module.exports = __webpack_public_path__ + "media/images/lb/401-ffcbabb18190278f7f382284640a9643.svg";